module.exports = __webpack_public_path__ + "img/study-pro.b839382e.png";